import React, { useMemo } from 'react';

// Components
import * as S from './Styled';
import { useTranslation } from 'react-i18next';
import { footerMenu } from '../../config/menu';

const Menu = props => {
  const { t } = useTranslation();

  const links = useMemo(
    () =>
      footerMenu?.filter(i =>
        props?.menuKeys?.includes(i?.to?.replace(/\//, ''))
      ),
    [props.menuKeys]
  );

  return (
    <S.Menu>
      {links?.map(link => (
        <S.StyledLink to={link.to} key={link.to}>
          {t(link.label)}
        </S.StyledLink>
      ))}
    </S.Menu>
  );
};

export default Menu;
